var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 2.66683H8.9165V1.50016C8.9165 0.858496 8.3915 0.333496 7.74984 0.333496H4.24984C3.60817 0.333496 3.08317 0.858496 3.08317 1.50016V2.66683H1.33317C0.691504 2.66683 0.166504 3.19183 0.166504 3.8335V9.66683H11.8332V3.8335C11.8332 3.19183 11.3082 2.66683 10.6665 2.66683ZM4.24984 1.50016H7.74984V2.66683H4.24984V1.50016ZM10.6665 8.50016H1.33317V6.75016H2.49984V7.3335H3.6665V6.75016H8.33317V7.3335H9.49984V6.75016H10.6665V8.50016ZM9.49984 5.5835V5.00016H8.33317V5.5835H3.6665V5.00016H2.49984V5.5835H1.33317V3.8335H10.6665V5.5835H9.49984Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIcon);
export default __webpack_public_path__ + "static/media/suitcaseIcon.5c56721f2d7b1de8a97b4b22a23d0917.svg";
export { ForwardRef as ReactComponent };